import React from 'react'
import { Category } from 'lib/types'
import { NotFound } from 'lib/shared'
import { useCategoryByPath } from 'lib/modules/catalog'

interface Props {
  children: (props: { category: Category }) => JSX.Element
}

export const CategoryResolver = ({ children }: Props) => {
  const { category } = useCategoryByPath()

  if (!category) {
    return (
      <NotFound />
    )
  }

  return children({ category })
}
